import { useContext } from "react";
//import { useState } from "react";

import { Grid, Grow } from "@material-ui/core";
import TextField from "../../../../components/basics/TextFieldErp";
import Select from "../../../../components/basics/SelectErp";
import Card from "../../../../components/cards/Card";

import { Exportacao } from "../styles/Emissao";
import { Estados } from "../../../../repositories/qerpapi/erp/prouser/static/Estados";
import { EmissaoContext } from "../contexts/EmissaoContext";

const TabEmissaoExportacao = ({ ...props }) => {
  const {
    exportDispatchLocation,
    setExportDispatchLocation,
    exportShipmentLocation,
    setExportShipmentLocation,
    ufExport,
    setUfExport,
  } = useContext(EmissaoContext);

  const listEstados = Estados.filter(function (obj) {
    return obj.nome !== "EXTERIOR";
  });

  return (
    <Exportacao>
      <Card line="left" lineColor="primary">
        <Grow in={true}>
          <Grid container spacing={2}>
            <Grid item sm={12}>
              <Select
                value={ufExport}
                setValue={setUfExport}
                optionsList={listEstados}
                descriptionField="estado"
                label="Uf Saída País"
              />
            </Grid>
            <Grid item lg={12} sm={12}>
              <TextField
                value={exportShipmentLocation}
                setValue={setExportShipmentLocation}
                label="Local Embarque"
                multiline
                maxLength={60}
              />
            </Grid>
            <Grid item lg={12} sm={12}>
              <TextField
                value={exportDispatchLocation}
                setValue={setExportDispatchLocation}
                label="Local Despacho"
                multiline
                maxLength={60}
              />
            </Grid>
          </Grid>
        </Grow>
      </Card>
    </Exportacao>
  );
};

export default TabEmissaoExportacao;
